import { render, staticRenderFns } from "./CarriersTable.vue?vue&type=template&id=3b5ddd58"
import script from "./CarriersTable.vue?vue&type=script&lang=js"
export * from "./CarriersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports